import { Injectable, AfterViewInit } from '@angular/core';
import { WsService }from '../../utils/network/ws.service';
declare var AdapterJS;
declare var RTCPeerConnection;
declare var RTCSessionDescription;
declare var attachMediaStream;
declare var RTCIceCandidate;
declare var $;
declare var navigator
@Injectable()
export class MediaService implements AfterViewInit {

	_peers = [];
    processed = [];
	constructor(private wsService: WsService) { }
	private setProcessedIces(id, processed) {
		this.processed[id] = processed;
	}
	resetPeer(id) {
		if (this._peers[id]) {
			var p = this._peers[id];
			try {
				console.log("Will try to close " + id);
				p.close();
				console.log("ID " + id + " has been closed");
			} catch (error) {
				console.error(error);
			}
			delete this._peers[id];
		}

	}
	onPeerTalkingCallbacks = [];
	private peerTalking(id, talking) {
		for (var c of this.onPeerTalkingCallbacks) {
			c.onPeerTalking(id, talking);
		}
	}
	private getStat(pc, id) {
		try {
			if (!pc.getRemoteStreams()[0]) {
				return
			}
			var selector = pc.getRemoteStreams()[0].getAudioTracks()[0];
			var self = this
			if (selector)
				pc.getStats(selector, function (report) {
					var results = report;
					for (var rr in results) {
						var c = results[rr]
						var v = c.audioOutputLevel / 32767;
						self.peerTalking(id, v > 0.005);
						continue;
					}
				}, function (e) {
					console.log(e);
				})
		} catch (error) {

		}
	}
	registerForOnPeerTalking(cb) {
		this.onPeerTalkingCallbacks.push(cb);
		if (this.onPeerTalkingCallbacks.length == 1) {
			var self = this;
			setInterval(function () {
				for (var id in self._peers) {
					var p = self._peers[id];
					self.getStat(p, id);
				}
			}, 250);
		}
	}
	createPeer(id, stream, hash, media) {
		//var peerOrig = id;
		var _this = this;
		//id = this.getUserId(id, sharingScreen);
		//this.setProcessedIces(id, false);
		var configuration = {
			iceServers: [

				{ url: 'stun:stun.l.google.com:19302' },
				{ url: 'stun:stun1.l.google.com:19302' },
				{ url: 'stun:stun2.l.google.com:19302' },
				{ url: 'stun:stun3.l.google.com:19302' },
				{ url: 'stun:stun4.l.google.com:19302' },
				{
					'url': 'turn:52.169.13.8:443',
					'credential': 'svilen',
					'username': 'svilen'
				  },
			]
		};
		//console.log("creating peer connection for " + id);

		var pc = new RTCPeerConnection(configuration);
		console.log("pc created")
		pc.onicecandidate = function (candidate) {
			console.log("Got candidate ", candidate)

			if (candidate.candidate) {
				var c = candidate.candidate
				candidate = { candidate: c.candidate, sdpMid: c.sdpMid, sdpMLineIndex: c.sdpMLineIndex }
				console.log("Got candidate ", candidate);
				_this.onIce(hash, candidate);
			}
		};


		var offerVideo;
		var offerAudio;
		if (stream) {
			pc.addStream(stream);
			if (media != 'sharing') {
				var element = $("#video-" + hash)[0];
				console.log("Adding stream to element", element)
				element = attachMediaStream(element, stream);
			}
			offerVideo = offerAudio = false;
		} else {
			pc.onaddstream = function (e) {
				console.log("Got event on add stream")
				var element = $("#video-" + hash)[0];
				element = attachMediaStream(element, e.stream);
				if (e.stream.getVideoTracks() && e.stream.getVideoTracks().length > 0)
					e.stream.getVideoTracks()[0].onended = function () {
						console.log("Video of peer " + hash + " stopped");
					}
			}
			offerVideo = this.getVideo(media);
			offerAudio = this.getAudio(media);
		}
		this._peers[hash] = pc;
		var offerConstraints
	/*	if (webrtcDetectedBrowser=='firefox'){
			offerConstraints = {offerToReceiveAudio: offerAudio,
				    	offerToReceiveVideo: offerVideo
			};
		}else{
	*/		offerConstraints = {
			mandatory:
			{
				OfferToReceiveAudio: offerAudio,
				OfferToReceiveVideo: offerVideo
			}
			, optional: [{ DtlsSrtpKeyAgreement: true }, { "IceRestart": true }]
		};
		//	}
		console.log("offer constaints", JSON.stringify(offerConstraints));

		pc.createOffer(function (desc) {
			pc.setLocalDescription(desc);
			_this.onSdp(desc.sdp, media, stream != null, id, hash);

		}, function (error) {
			console.error(error)
		}, offerConstraints);
		return pc;
	}
	private onSdp(sdp, media, me, id, hash) {
		//this.wsService.send("handshake", { "outgoing": me, sdp: sdp, media: media, hash: hash, callee: id });
		this.sendHandshake(me, media, hash, id, sdp);
	}
	/***
	 * Used when ws says to change the source, stop video for example.
	 */
	private stopOutgoingStream(stream) {
		if (stream) {
			try {
				for (let i = 0; i < stream.getTracks().length; i++) {
					stream.getTracks()[i].stop();
				}
				stream = null;
			} catch (error) {
				console.log(error);
			}

		}
	}
	stream: any;
	sendIncoming(id, hash, media) {

		this._send(id, hash, media, false);
	}
	getVideo(media) {
		return media == "both" || media == "video" || media == "sharing";
    }
	getAudio(media) {
		return media == "both" || media == "audio";
	}
	private _sendIncoming(id, hash, media) {
		var video = this.getVideo(media);
		var audio = this.getAudio(media);
		this.resetPeer(hash);
		if (!audio && !video) {
			this.sendHandshake(false, "none", hash, id, null);
			return;
		}

		this.createPeer(id, null, hash, media);
	}
	private _send(id, hash, media, outgoing) {
		var _this = this;
		setTimeout(function () {
			if (outgoing)
				_this._sendOutgoing(media);
			else
				_this._sendIncoming(id, hash, media);
		}, 100);
	}

	sendOutgoing(media) {

		this._send(null, null, media, true);
	}
private sendHandshake(outgoing, media, hash, callee, sdp){
this.wsService.send("handshake", { "outgoing": outgoing, sdp: sdp, media: media, hash: hash, callee: callee });
}
	private _sendOutgoing(media) {
		var video = this.getVideo(media);
		var audio = this.getAudio(media);
		console.log("Got media", media)
		let id = this.wsService.userHash;
		this.stopOutgoingStream(this.stream);
		this.resetPeer(id);
		if (!video && !audio) {
			this.sendHandshake(true, "none", id, id, null);
		//	this.wsService.send("handshake", { "outgoing": true, media: "none", hash: id, callee: id });
			return;
		}
		console.log("Will get stream ")
		var constraints = {
			audio: audio,

		};

		if (!video) {
			constraints['video'] = false;
		} else {
			constraints['video'] = {
				mandatory: {
					//maxWidth: 480,
					//	maxFrameRate: 10,
					//		minFrameRate: 8
				}
			}
		}
		var _this = this;


		var fn = function () {
			console.log("GETIng user media, looks like adapter js is ready")
			navigator.getUserMedia(constraints, function (stream) {
                console.log("Got stream ", stream)
				_this.stream = stream;
				console.log("Will create peer for " + id);
				if (typeof stream == 'undefined') {
					console.log("Couldnt get stream");
					return;
				} else {
					console.log("Stream is fine", stream);
				}
				_this.createPeer(id, stream, id, media);
			}, function (error) {
				console.log("error in getting user media ", error);
			});
		}

		AdapterJS.webRTCReady(fn);
	}
	private onIce(hash, candidate) {
		this.wsService.send("onIce", { candidate: candidate, hash: hash });
	}
	processAnswer(hash, sdp) {
		console.log("Processing answer for " + hash);
		this._peers[hash].setRemoteDescription(new RTCSessionDescription({ sdp: sdp, type: 'answer' }), function () {
		}, function (error) {
			console.log("Error while setting remote description ", error)
		});
	}
	addCandidate(hash, candidate) {
		console.log("Adding candidate to " + hash);
		this._peers[hash].addIceCandidate(new RTCIceCandidate(candidate),
			function () {
				console.log("Added candidate");
			}, function (e) {
				console.log("Got event ", e)
			});
	}
	close() {
		console.log("Will close")
		this.stopOutgoingStream(this.stream);
		this.stopOutgoingStream(this.sharingStream);
		for (let p in this._peers) {
			this.resetPeer(p);
		}
	}
	getSourceId() {
		console.log("Starting");
		window.postMessage('get-sourceId', '*');
	}
	hasShareScreenPluginInstalled = false;
	onShareScreenStreamEnded() {
		console.log("Share screen has ended");
		var hash = this.getSharingHash();
		this.stopOutgoingStream(this.sharingStream);
		this.resetPeer(hash);
		this.sendStopMedia(hash, "sharing");
	}
	private sendStopMedia(hash, media){
this.wsService.send("stop-media", { hash: hash, media: media })
	}
	private getSharingHash() {
		return "sharing-" + this.wsService.userHash;
	}
	
	sharingStream;
	onShareScreenStream(stream) {
		this.sharingStream = stream;
		console.log("Got share screen ", stream);
		//var id = this.getUserId(this.wsService.userHash, true);
		this.createPeer(this.wsService.userHash, stream, this.getSharingHash(), "sharing");
	}
	startSharing(sourceId) {
		console.log("Will start sharing ", sourceId);
		var _this = this;
		var screen_constraints = {
			mandatory: {
				chromeMediaSource: "desktop",
				maxWidth: 1920,
				maxHeight: 1080,
				minAspectRatio: 1.77,
				chromeMediaSourceId: sourceId
			},
			optional: []
		};
		var session = {
			audio: false,
			video: screen_constraints
		};

		// now invoking native getUserMedia API
		navigator.webkitGetUserMedia(session, function (stream) {
			console.log("Got shared stream ", stream);
			stream.getVideoTracks()[0].onended = function () {
				console.log("User has stopped sharing");
				_this.onShareScreenStreamEnded();
			}
			_this.onShareScreenStream(stream);
		}, function (e) {
			console.log("On error in getting share screen ", e);
		});
	}
	_muteMedia(video, to) {
		if (!this.stream) return;
		var tracks;
		if (video) {
			tracks = this.stream.getVideoTracks();
		} else {
			tracks = this.stream.getAudioTracks();
		}
		for (let i = 0; i < tracks.length; i++) {
			tracks[i].enabled = to;
		}
	}
	mic(to) {
		this._muteMedia(false, to);
	}
	video(to) {
		this._muteMedia(true, to);
	}
	ngAfterViewInit() {
		var _this = this;

	}
	shareScreenOnMessageCallback(event) {
		if (event.origin != window.location.origin) {
			return;
		}
		console.log("Onmessage callback ", event.data);
		if (event.data == 'rtcmulticonnection-extension-loaded') {
			this.hasShareScreenPluginInstalled = true;
			this.getSourceId();
		}
		if (event.data.sourceId) {
			this.startSharing(event.data.sourceId);
		}
	}
	registeredForOnMessage = false;
	shareScreen(cb) {
		var ready = false;
		var _this = this;
		if (!this.registeredForOnMessage) {
			window.addEventListener('message', this.shareScreenOnMessageCallback.bind(this));
			this.registeredForOnMessage = true;
		}
		window.postMessage('are-you-there', '*');
		setTimeout(function () {
			if (!_this.hasShareScreenPluginInstalled) {
				cb(false);
			}
		}, 1000);

	}
}



// WEBPACK FOOTER //
// /app/src/app/wb/peers/media.service.ts